// import React from "react";

// const sizes = ["28", "30", "32", "34", "2 Mtr", "2.5 Mtr"];

// const SizeFilter = ({ filters, setFilters }) => {
//   const toggle = (value) => {
//     setFilters((prev) => ({
//       ...prev,
//       sizes: prev.sizes.includes(value)
//         ? prev.sizes.filter((s) => s !== value)
//         : [...prev.sizes, value]
//     }));
//   };

//   return (
//     <div>
//       <h4 className="font-medium mb-2">Sizes</h4>

//       <div className="space-y-2">
//         {sizes.map((size) => (
//           <label key={size} className="flex items-center gap-2 text-sm">
//             <input
//               type="checkbox"
//               checked={filters.sizes.includes(size)}
//               onChange={() => toggle(size)}
//             />
//             {size}
//           </label>
//         ))}
//       </div>

//       <input
//         placeholder="Custom size"
//         className="mt-2 w-full border px-2 py-1 text-sm rounded"
//         onKeyDown={(e) => {
//           if (e.key === "Enter") {
//             toggle(e.target.value);
//             e.target.value = "";
//           }
//         }}
//       />
//     </div>
//   );
// };

// export default SizeFilter;


import React from "react";

const SizeFilter = ({ filters, setFilters, availableSizes }) => {
  const toggle = (size) => {
    setFilters((prev) => ({
      ...prev,
      sizes: prev.sizes.includes(size)
        ? prev.sizes.filter((s) => s !== size)
        : [...prev.sizes, size]
    }));
  };

  // 🟢 Hide filter if category has no sizes
  if (!availableSizes || availableSizes.length === 0) {
    return null;
  }

  return (
    <div>
      <h4 className="font-medium mb-3">Sizes</h4>

      <div className="space-y-2 max-h-56 overflow-y-auto">
        {availableSizes.map((size) => (
          <label
            key={size}
            className="flex items-center gap-2 text-sm cursor-pointer"
          >
            <input
              type="checkbox"
              checked={filters.sizes.includes(size)}
              onChange={() => toggle(size)}
            />
            <span>{size}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default SizeFilter;
